const prefix = 'user-details';

const SET_USER_DETAILS = `${prefix}/SET_USER_DETAILS`;

const SET_PERMISSION = `${prefix}/SET_PERMISSION`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_USER_DETAILS, RESET, SET_PERMISSION, SET_LOADING };
